import app from '@src/app';

app.init();
